let _token = null

export function parseToken () {
  const queryString = window.location.search.slice(1)

  if (!queryString) {
    return false
  }

  const attributes = queryString
    .split('&')
    .map(item => item.split('='))
    .reduce((m, i) => {
      m[i[0]] = i[1]
      return m
    }, {})

  _token = attributes.token || null
}

export function loadEnvironment () {
  return fetch(route('/api/environment'), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => {
    if (r.status !== 200) {
      return null
    }

    return r.json()
  })
}

export function route (p) {
  return p + '?token=' + _token
}
